export var CommonSchemaIds;
(function (CommonSchemaIds) {
    CommonSchemaIds["VISIBLE"] = "visible";
})(CommonSchemaIds || (CommonSchemaIds = {}));
